var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1507_44451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8511 6.2648C14.4561 4.696 12.4707 3.7937 10.3521 3.7937C6.30126 3.7937 3.00536 7.0608 3.00536 11.0764V16.7097C3.00536 17.6159 3.74656 18.3533 4.65766 18.3533H9.04366C10.3142 19.5005 11.9941 20.2063 13.8413 20.2063H19.3677C20.2652 20.2063 20.9947 19.4792 20.9947 18.5852V13.0925C20.9947 9.8626 18.8194 7.1328 15.8511 6.2648ZM4.50536 16.7097V11.0764C4.50536 7.8879 7.12836 5.2937 10.3521 5.2937C11.3472 5.2937 12.3028 5.5488 13.1504 6.0076C9.52926 6.353 6.68696 9.3956 6.68696 13.0882C6.68696 14.4714 7.09196 15.7595 7.78096 16.8533H4.65766C4.57366 16.8533 4.50536 16.7888 4.50536 16.7097ZM19.4947 18.5852C19.4947 18.6521 19.4381 18.7063 19.3677 18.7063H13.8413C10.7231 18.7063 8.18696 16.1853 8.18696 13.0867C8.18696 9.9915 10.7222 7.4729 13.8374 7.4729C16.9565 7.4729 19.4946 9.9939 19.4946 13.0925L19.4947 18.5852Z",
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4121 12.2494C10.9436 12.2494 10.5637 12.6256 10.5637 13.0895C10.5637 13.5534 10.9436 13.9296 11.4121 13.9296C11.8806 13.9296 12.2602 13.5535 12.2602 13.0895C12.2602 12.6255 11.8806 12.2494 11.4121 12.2494Z",
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8404 12.2494C13.3719 12.2494 12.9923 12.6256 12.9923 13.0895C12.9923 13.5534 13.3719 13.9296 13.8404 13.9296C14.3089 13.9296 14.6888 13.5535 14.6888 13.0895C14.6888 12.6255 14.3089 12.2494 13.8404 12.2494Z",
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2688 12.2494C15.8003 12.2494 15.4204 12.6256 15.4204 13.0895C15.4204 13.5534 15.8003 13.9296 16.2688 13.9296C16.7373 13.9296 17.1172 13.5535 17.1172 13.0895C17.1172 12.6255 16.7373 12.2494 16.2688 12.2494Z",
    fill: "#EDEFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1507_44451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/menu4.8ed028f654fd28b6b0a0bc322f21972c.svg";
export { ForwardRef as ReactComponent };